const getSubscriptionText = (text: string, isHousinAssociation: boolean) => {
	if (!isHousinAssociation) {
		return text;
	}

	let output = text.replace("bedriftsbillett", "månedsbillett");
	output = output.replace("Bedriftsbillett", "Månedsbillett");

	return output;
};

export default getSubscriptionText;
